import styled from "styled-components";
import { Container } from "@util/standard";
import { mediaQuery, colors } from "@util/constants";

export const TextCtaWrapper = styled(Container)<{
  contentLength: number;
  enableBackgroundDesign?: boolean;
  link?: string;
}>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 100px;
  ${({ link }) => (link ? `grid-gap: 20px;` : `grid-gap: 100px;`)}
  ${({ enableBackgroundDesign }) =>
    enableBackgroundDesign &&
    `
    background-color:${colors.lightGrey};
  `}
  ${({ contentLength }) =>
    contentLength === 1 &&
    `
    grid-template-columns:1fr;
    grid-page:0;
  `}
  ${({ contentLength, enableBackgroundDesign }) =>
    contentLength === 2 &&
    enableBackgroundDesign &&
    `
    align-items:flex-end;
    grid-template-columns:2fr 1fr;
    ${mediaQuery.mediumUp}{
      .column:nth-child(2){
        .block-content-row-button{
          text-align:right; 
        }
      }
    }
  `}
  ${mediaQuery.largeDown} {
    width: 100%;
  }
  ${({ link }) =>
    link &&
    `width: 80%;
    margin: auto;
    padding-left: 0;
    padding-right: 0;
  `};
  ${mediaQuery.mediumDown} {
    grid-template-columns: 1fr;
    grid-gap: 15px;
  }
`;
